import React, { useState, useEffect } from 'react'
import { yogaStyles} from '../../../Utilities/yogaStyles'
import { useAuth } from '../../../Context/AuthContext'
import { toast } from 'react-toastify'
import axios from 'axios'

export default function ClassModal({setOpen, teachers, getClasses}) {

    let { currentUser } = useAuth()

    const [name, setName] = useState("")
    const [style, setStyle] = useState("")
    const [teacherId, setTeacherId] = useState("")
    const [teacherName, setTeacherName] = useState("")
    const [teacherImg, setTeacherImg] = useState("")
    const [start, setStart] = useState("")
    const [end, setEnd] = useState("")
    const [day, setDay] = useState("")
    const [spaces, setSpaces] = useState("")
    const [price, setPrice] = useState("")

    const [saving, setSaving] = useState(false)

    useEffect(() => {
        if(teacherId){
            let selected = teachers.filter((teacher) => teacher.teacherId === teacherId)
            setTeacherName(selected[0].name)
            setTeacherImg(selected[0].img)
        } else {
            return
        }

    }, [teacherId])

    const handleSubmit = () => {
        let payload = {
            name,
            style,
            teacherName,
            teacherId,
            teacherImg,
            day,
            studioId: currentUser.uid,
            studioName: currentUser.displayName,
            start,
            end,
            spaces,
            price,
            active: true
        }
        console.log(payload)
        if(!name || !style || !day || !start || !end || !spaces){
            toast.error("Please add all fields")        
        } else {
            setSaving(true)
            axios.post(`${process.env.REACT_APP_API_URL}/studios/add-class`, payload)
            .then(() => {
                setOpen(false)
                getClasses()
                toast.success("Successfully added")
                setSaving(false)

            })
            .catch((e) => {
                console.log(e)
                toast.error("Error creating")
                setSaving(false)

            })
        }
    }

    const handleDay = (day) => {
        setDay(day)

    }

  return (
    <div id='side-modal'>
        <div id='side-modal-container'>
            <button onClick={() => setOpen(false)} id='close-contest-btn'>x</button>

            <div className='side-modal-header'>
                <p className='om-header' style={{fontSize: 28}}>Add New Class</p>

                <p className='om-subheader' style={{fontSize: 16, margin: '10px 0'}}>Add a new regular class to automatically populate on your timetables</p>
            </div>
              <div className='new-contest-container'>

                <p className='om-header' style={{fontSize: 20, marginBottom: 10}}>Class Name</p>
                <input className='modal-input' type='text' placeholder='eg. Hatha'  value={name} onChange={(e) => setName(e.target.value)}/>
                
                <p className='om-header' style={{fontSize: 20, margin: '30px 0 10px 0'}}>Yoga Style (used for filtering only)</p>
                <select className='modal-input'  value={style} onChange={(e) => setStyle(e.target.value)}>
                    <option value="">Please select</option>
                    {yogaStyles.map((style, i) => {
                        return <option key={i} value={style}>{style}</option>
                    })}

                </select>

                <p className='om-header' style={{fontSize: 20, margin: '30px 0 10px 0'}}>Assign Teacher</p>
                <select className='modal-input'  value={teacherId} onChange={(e) => setTeacherId(e.target.value)}>
                    <option value="">Unallocated</option>
                    {teachers.map((teacher, i) => {
                        return (
                            <option key={i} value={teacher.teacherId}>{teacher.name}</option>
                        )
                    })}

                </select>

                <p className='om-header' style={{fontSize: 20, margin: '30px 0 10px 0'}}>Day of week</p>
                <div style={{display:'flex', justifyContent:'space-between', width: '80%'}}>
                    <div>
                        <p>M</p>
                        <input type='radio' name='days' value={1} onChange={(e) => handleDay(e.target.value)}/>
                    </div>
                    <div>
                        <p>T</p>
                        <input type='radio' name='days' value={2} onChange={(e) => handleDay(e.target.value)}/>
                    </div>
                    <div>
                        <p>W</p>
                        <input type='radio' name='days' value={3} onChange={(e) => handleDay(e.target.value)}/>
                    </div>
                    <div>
                        <p>T</p>
                        <input type='radio' name='days' value={4} onChange={(e) => handleDay(e.target.value)}/>
                    </div>
                    <div>
                        <p>F</p>
                        <input type='radio' name='days' value={5} onChange={(e) => handleDay(e.target.value)}/>
                    </div>
                    <div>
                        <p>S</p>
                        <input type='radio' name='days' value={6} onChange={(e) => handleDay(e.target.value)}/>
                    </div>
                    <div>
                        <p>S</p>
                        <input type='radio' name='days' value={0} onChange={(e) => handleDay(e.target.value)}/>
                    </div>
                </div>

                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div style={{width: '45%'}}>
                        <p className='om-header' style={{fontSize: 20, margin: '30px 0 10px 0'}}>Start time</p>
                        <input className='modal-input'  type='time' value={start} onChange={(e) => setStart(e.target.value)}/>
                    </div>
                    <div style={{width: '45%'}}>
                        <p className='om-header' style={{fontSize: 20, margin: '30px 0 10px 0'}}>End time</p>
                        <input className='modal-input'  type='time' value={end} onChange={(e) => setEnd(e.target.value)}/>
                    </div>

                   
                </div>

                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div style={{width: '45%'}}>
                        <p className='om-header' style={{fontSize: 20, margin: '30px 0 10px 0'}}>Class price</p>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: '5px' }}>£</span>
                            <input className='modal-input' type='number' value={price} onChange={(e) => setPrice(e.target.value)} />
                        </div>
                    </div>
                    <div style={{width: '45%'}}>
                        <p className='om-header' style={{fontSize: 20, margin: '30px 0 10px 0'}}>Spaces available</p>
                        <input className='modal-input'  type='number' value={spaces} onChange={(e) => setSpaces(e.target.value)}/>
                    </div>

                   
                </div>
                


          
                <button style={{marginTop: 20}} className='primary-btn' onClick={handleSubmit} disabled={saving}>{saving? "Creating" :"Create class"}</button>
              </div>

        </div>
    </div>
  )
}
